import { GET_LOADER} from "./types";

const getLoaderActions = (prop) => dispatch =>{

        dispatch({
            type:GET_LOADER,
            payload: prop,
        })
    

}
export default getLoaderActions